import { createContext, useCallback, useContext, useState } from "react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "../ui/dialog";
import { RfqForm } from "./RfqForm";

const RfqCtx = createContext({ open: () => {} });
export const useRfq = () => useContext(RfqCtx);

export const RfqProvider = ({ children }) => {
  const [st, setSt] = useState({ open: false, product: "", productId: "", extra: {}, key: 0 });
  const open = useCallback((product = "", productId = "", extra = {}) => setSt((p) => ({ open: true, product, productId, extra, key: p.key + 1 })), []);

  return (
    <RfqCtx.Provider value={{ open }}>
      {children}
      <Dialog open={st.open} onOpenChange={(v) => setSt((p) => ({ ...p, open: v }))}>
        <DialogContent data-testid="rfq-modal" className="max-h-[92vh] max-w-2xl overflow-y-auto rounded-none border border-slate-700 bg-[#0d121b] p-6 text-white sm:p-10" data-lenis-prevent>
          <p className="eyebrow text-sky-400">Request for quotation</p>
          <DialogTitle className="font-display text-4xl font-extrabold uppercase leading-none sm:text-5xl">Get a quote</DialogTitle>
          <DialogDescription className="text-sm text-slate-300">
            Share a few details. Pricing is shared on request based on drawing, compound and volume.
          </DialogDescription>
          <div className="mt-4">
            <RfqForm key={st.key} dark defaultProduct={st.product} productId={st.productId} defaults={st.extra} />
          </div>
        </DialogContent>
      </Dialog>
    </RfqCtx.Provider>
  );
};
